<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4"><a href="#/Hidden_Heritage2#Contents-A">Dedication</a></p>
<p class="fp para-style-override-3"><span class="Italic">Hidden Heritage</span> is dedicated to the memory of my beloved husband, Don Hinger. His wisdom, love, and integrity inspired and sustained me throughout our long marriage. </p>
<p class="body para-style-override-4"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hidden_Heritage-3.vue?6d4352cb